const insourced = {
    year1: {
      nocStaff: {
        teamLeads: { cost: 150000, quantity: 3, total: 450000 },
        seniorEngineers: { cost: 120000, quantity: 9, total: 1080000 },
        networkEngineers: { cost: 90000, quantity: 15, total: 1350000 },
        juniorEngineers: { cost: 70000, quantity: 12, total: 840000 },
        total: 3720000
      },
      regionalSupportTeams: {
        emea: { cost: 120000, quantity: 6, total: 720000 },
        usa: { cost: 130000, quantity: 6, total: 780000 },
        china: { cost: 90000, quantity: 6, total: 540000 },
        total: 2040000
      },
      managementAndSupport: {
        programManagement: { cost: 180000, quantity: 1, total: 180000 },
        technicalArchitect: { cost: 160000, quantity: 2, total: 320000 },
        toolsAndAutomation: { cost: 130000, quantity: 3, total: 390000 },
        total: 890000
      },
      benefitsAndOverhead: {
        percentage: 30,
        baseAmount: 6650000,
        total: 1995000
      },
      technologyAndTools: {
        softwareLicenses: { cost: 400000, quantity: 1, total: 400000 },
        monitoringSystems: { cost: 250000, quantity: 1, total: 250000 },
        automationTools: { cost: 200000, quantity: 1, total: 200000 },
        documentationSystems: { cost: 100000, quantity: 1, total: 100000 },
        total: 950000
      },
      operationalCosts: {
        trainingAndCertifications: { cost: 200000, quantity: 1, total: 200000 },
        travelAndRegionalSupport: { cost: 300000, quantity: 1, total: 300000 },
        facilitiesAndEquipment: { cost: 400000, quantity: 1, total: 400000 },
        circuitProviderManagement: { cost: 150000, quantity: 1, total: 150000 },
        total: 1050000
      },
      totalAnnualPersonnel: 8645000,
      totalOperationalCosts: 10645000,
      oneTimeInitiationCosts: 1600000,
      yearTotal: 12245000
    },
    year2: {
      nocStaff: {
        teamLeads: { cost: 150000, quantity: 3, total: 450000 },
        seniorEngineers: { cost: 120000, quantity: 9, total: 1080000 },
        networkEngineers: { cost: 90000, quantity: 15, total: 1350000 },
        juniorEngineers: { cost: 70000, quantity: 12, total: 840000 },
        total: 3720000
      },
      regionalSupportTeams: {
        emea: { cost: 120000, quantity: 6, total: 720000 },
        usa: { cost: 130000, quantity: 6, total: 780000 },
        china: { cost: 90000, quantity: 6, total: 540000 },
        total: 2040000
      },
      managementAndSupport: {
        programManagement: { cost: 180000, quantity: 1, total: 180000 },
        technicalArchitect: { cost: 160000, quantity: 2, total: 320000 },
        toolsAndAutomation: { cost: 130000, quantity: 3, total: 390000 },
        total: 890000
      },
      benefitsAndOverhead: {
        percentage: 30,
        baseAmount: 6650000,
        total: 1995000
      },
      technologyAndTools: {
        softwareLicenses: { cost: 400000, quantity: 1, total: 400000 },
        monitoringSystems: { cost: 250000, quantity: 1, total: 250000 },
        automationTools: { cost: 200000, quantity: 1, total: 200000 },
        documentationSystems: { cost: 100000, quantity: 1, total: 100000 },
        total: 950000
      },
      operationalCosts: {
        trainingAndCertifications: { cost: 200000, quantity: 1, total: 200000 },
        travelAndRegionalSupport: { cost: 300000, quantity: 1, total: 300000 },
        facilitiesAndEquipment: { cost: 400000, quantity: 1, total: 400000 },
        circuitProviderManagement: { cost: 150000, quantity: 1, total: 150000 },
        total: 1050000
      },
      totalAnnualPersonnel: 8645000,
      totalOperationalCosts: 10645000,
      oneTimeInitiationCosts: 0,
      yearTotal: 10964350
    },
    year3: {
      nocStaff: {
        teamLeads: { cost: 150000, quantity: 3, total: 450000 },
        seniorEngineers: { cost: 120000, quantity: 9, total: 1080000 },
        networkEngineers: { cost: 90000, quantity: 15, total: 1350000 },
        juniorEngineers: { cost: 70000, quantity: 12, total: 840000 },
        total: 3720000
      },
      regionalSupportTeams: {
        emea: { cost: 120000, quantity: 6, total: 720000 },
        usa: { cost: 130000, quantity: 6, total: 780000 },
        china: { cost: 90000, quantity: 6, total: 540000 },
        total: 2040000
      },
      managementAndSupport: {
        programManagement: { cost: 180000, quantity: 1, total: 180000 },
        technicalArchitect: { cost: 160000, quantity: 2, total: 320000 },
        toolsAndAutomation: { cost: 130000, quantity: 3, total: 390000 },
        total: 890000
      },
      benefitsAndOverhead: {
        percentage: 30,
        baseAmount: 6650000,
        total: 1995000
      },
      technologyAndTools: {
        softwareLicenses: { cost: 400000, quantity: 1, total: 400000 },
        monitoringSystems: { cost: 250000, quantity: 1, total: 250000 },
        automationTools: { cost: 200000, quantity: 1, total: 200000 },
        documentationSystems: { cost: 100000, quantity: 1, total: 100000 },
        total: 950000
      },
      operationalCosts: {
        trainingAndCertifications: { cost: 200000, quantity: 1, total: 200000 },
        travelAndRegionalSupport: { cost: 300000, quantity: 1, total: 300000 },
        facilitiesAndEquipment: { cost: 400000, quantity: 1, total: 400000 },
        circuitProviderManagement: { cost: 150000, quantity: 1, total: 150000 },
        total: 1050000
      },
      totalAnnualPersonnel: 8645000,
      totalOperationalCosts: 10645000,
      oneTimeInitiationCosts: 0,
      yearTotal: 11283700
    },
    threeYearTotal: 34493050
  };
  
  export default insourced;